import { Grid } from "@mui/material";
import MxFormL3TextNumber from "@rf-l3/form/MxFormL3NumberField";
import { memo, useMemo } from "react";
import { CPropertyFormKeys } from "@rf/property/module/components/property-form/util/schemas/property-schema/propertySchema";
import MxFormL3RushRadioDuoField from "@rf-l3/form/MxFormL3RushRadioDuo";
import {
  A_YES_AND_NOT,
  C_YES_AND_NOT
} from "@/src-refactor/modules/shared/model/const/yes-and-not.conts";
import MxFormL3TextAreaField from "@rf-l3/form/MxFormL3TextAreaField";
import HCheckArray from "@rf-helper/check-have-value";
import { useFormValidationsDocumentsMsgSlice } from "../../../store/slices/form-validations-documents-msg/FormValidationsDocumentsMsgSlice";
import useShowValidationInfo from "@rf/property/module/components/modal/useShowValidationInfo";
import { IFileData } from "@rf-l1/file/helpers/create-file-data";
import MxFormSubTitle from "@rf-l1/page/form/MxFormSubTitle";
import useFormWatch from "@rf-hooks/useFormWatch";
import MxFormL4DocumentFileProperty from "@/src-refactor/modules/shared/components/refactor/components/l4/form/MxFormL4DocumentFileProperty";
import { CDocumentKeys } from "../../../util/model/documents-types";
import useRevalidateDocumentDeps from "../../../hooks/useRevalidateDocumentDeps";

const CadastralDataFormSection = () => {
  useRevalidateDocumentDeps();
  const {
    validationDocuments: { file_title_property }
  } = useFormValidationsDocumentsMsgSlice();
  const { showNotification } = useShowValidationInfo();

  const handleOnClickOnExternalIndicators = (
    file: IFileData | null,
    ctx: any,
    itemCtx: any
  ) => {
    showNotification(itemCtx.msg, itemCtx.status);
  };

  return (
    <Grid container spacing={2}>
      <Grid container item xs={12}>
        <MxFormSubTitle label="Datos catastrales" isRequired={true}></MxFormSubTitle>
      </Grid>
      <Grid container item xs={12} md={10} lg={10} spacing={2}>
        <Grid container item xs={12} md={6} lg={4}>
          <MxFormL3TextNumber
            withreacthookform={1}
            label="Número de matricula"
            name={CPropertyFormKeys.registration_number}
          />
        </Grid>
        <Grid container item xs={12} md={6} lg={4}>
          <MxFormL3RushRadioDuoField
            withreacthookform={1}
            items={A_YES_AND_NOT}
            label="Tiene hipoteca"
            name={CPropertyFormKeys.have_mortgage_property}
          />
        </Grid>
      </Grid>
      <Grid container item xs={12} md={10} lg={10} spacing={2}>
        <Grid item xs={12} md={6} lg={4}>
          <MxFormL4DocumentFileProperty
            withreacthookform={1}
            name={CPropertyFormKeys.file_title_property}
            label="Título de propiedad"
            minSize={0}
            maxSize={7}
            typeKey={CDocumentKeys.Title}
          />
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <PrivateNoteField />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default memo(CadastralDataFormSection);

const PrivateNoteField = () => {
  const { have_mortgage_property } = useFormWatch([
    CPropertyFormKeys.have_mortgage_property
  ]);

  const canAddNote = useMemo(() => {
    if (HCheckArray(have_mortgage_property)) {
      return have_mortgage_property[0].value == C_YES_AND_NOT.YES.value;
    }
    return false;
  }, [have_mortgage_property]);

  return (
    <MxFormL3TextAreaField
      label="Nota privada: "
      withreacthookform={1}
      name={CPropertyFormKeys.notes_property}
      disabled={!canAddNote}
      style={{ height: "225px" }}
    />
  );
};
